export const timings = {
  start: 1,
  intro: false,
  choise: 2,
  add: 5.8,
  after: 5,
}

export const choicePopup = {
  first: 12,
  second: 8,
}
